import React, { Suspense, lazy } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { AgitationSection } from '../components/AgitationSection';
import { RevelationSection } from '../components/RevelationSection';
// Lazy-load below-fold sections to reduce initial JS payload
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferSection = lazy(() => import('../components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ClosingSection = lazy(() => import('../components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const RecentPurchaseToast = lazy(() => import('../components/RecentPurchaseToast').then(m => ({
  default: m.RecentPurchaseToast
})));
function SectionFallback() {
  return <div className="py-16" data-id="element-642" />;
}
export function SalesPage() {
  return <div className="min-h-screen bg-cream selection:bg-gold/30" data-id="element-643">
      <UrgencyBar data-id="element-644" />
      <main data-id="element-645">
        <HeroSection data-id="element-646" />
        <AgitationSection data-id="element-647" />
        <RevelationSection data-id="element-648" />
        <Suspense fallback={<SectionFallback data-id="element-650" />} data-id="element-649">
          <TestimonialsSection data-id="element-651" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-653" />} data-id="element-652">
          <OfferSection data-id="element-654" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-656" />} data-id="element-655">
          <PricingSection data-id="element-657" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-659" />} data-id="element-658">
          <FAQSection data-id="element-660" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-662" />} data-id="element-661">
          <GuaranteeSection data-id="element-663" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-665" />} data-id="element-664">
          <ClosingSection data-id="element-666" />
        </Suspense>
      </main>
      <footer className="bg-charcoal text-cream/40 py-8 text-center text-sm border-t border-white/10" data-id="element-667">
        <p data-id="element-668">
          © 2026 El Protocolo de la Piel de Lujo. Todos los derechos
          reservados.
        </p>
      </footer>
      <Suspense fallback={null} data-id="element-669">
        <RecentPurchaseToast data-id="element-670" />
      </Suspense>
    </div>;
}